// extracted by mini-css-extract-plugin
export default {"stage":"FinanceActivationValues_stage__x9Dt6"};